import { render, staticRenderFns } from "./mob-detail.vue?vue&type=template&id=a71fdfb6&scoped=true"
import script from "./mob-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mob-detail.vue?vue&type=style&index=0&id=a71fdfb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71fdfb6",
  null
  
)

export default component.exports